export type Implementation = {
  title: string; technology: string; paragraphs: string[]; flow?: string[];
  image?: { file: string; alt: string; caption: string };
};
export type DetailedProject = {
  hero: { file: string; alt: string; caption: string };
  implementations: Implementation[];
  technology: { name: string; use: string }[];
  problem: { title: string; paragraphs: string[] };
};

export const projectDetails: Record<string, DetailedProject> = {
  pagomoa: {
    hero: { file: 'pagomoa/world.jpg', alt: 'PagoMoa 사막 필드의 플레이어와 동료', caption: '팀 프로젝트의 인게임 영상에서 추출한 필드 장면.' },
    implementations: [
      { title: '이벤트 기반 퀘스트와 제작 도구', technology: 'C# · 이벤트 구독 · IQuestElements · ScriptableObject · CustomEditor', paragraphs: [
        '아이템 수집·사용·판매와 블록 파괴처럼 서로 다른 행동을 퀘스트 조건으로 다뤄야 했습니다. 조건마다 필요한 게임플레이 이벤트를 구독하고, 이벤트가 발생하면 대상과 목표 수치를 비교해 진행도를 갱신하도록 구성했습니다.',
        '조건의 진행률, 완료 판정과 이벤트 해제는 IQuestElements 인터페이스로 묶었습니다. QuestManager는 선행 퀘스트 확인과 등록, 완료·보상을 처리하고 저장·로드 이벤트에 진행 상태를 연결합니다. 퀘스트마다 별도의 갱신 코드를 두는 대신 같은 처리 흐름에 조건 객체를 추가하는 방식입니다.',
        '제작 데이터는 ScriptableObject로 분리했습니다. Custom Inspector에서 퀘스트 ID와 선행 조건, 보상, 시작·완료 대화, 조건 타입과 목표 값을 편집할 수 있게 했습니다.'
      ], flow: ['아이템·월드 이벤트', '조건 객체의 진행도 갱신', '완료·보상 처리', '퀘스트 UI 갱신'] },
      { title: '인벤토리·퀵슬롯·장비 연동', technology: 'C# · 슬롯 데이터 · 이벤트 기반 UI 동기화', paragraphs: [
        '인벤토리 36칸, 퀵슬롯 6칸, 장비 4칸을 구분하고 아이템 추가·분할·합치기·이동·교환·사용·판매를 처리했습니다. 최대 중첩 수량을 기준으로 슬롯을 채우며, 공간이 부족하면 남은 수량을 감지합니다.',
        '퀵슬롯은 실제 인벤토리 수량과 동기화하고 중복 등록을 정리했습니다. 슬롯 데이터가 바뀌면 인벤토리 갱신과 아이템 수량·사용·판매 이벤트를 보내 UI와 퀘스트에 반영합니다. 장비 교환, 상점 구매·판매, 저장 데이터 생성·적용도 이 흐름에 연결했습니다.'
      ], image: { file: 'pagomoa/inventory.jpg', alt: 'PagoMoa의 인벤토리와 장비 슬롯 화면', caption: '인게임 영상의 인벤토리·장비 화면.' } },
      { title: 'Timeline 컷신과 Ink 대화', technology: 'PlayableDirector · Timeline 알림 · Cinemachine · Ink · uGUI', paragraphs: [
        '컷신 중 대화가 시작돼도 연출의 재생 위치를 유지해야 했습니다. CutSceneController가 Timeline 알림을 받고, DialogueMarker에서 PlayableDirector를 일시 정지한 뒤 Ink 스토리를 시작하도록 연결했습니다. 대화가 끝나면 Timeline 재생을 이어갑니다.',
        'Ink의 선택지와 talker·sprite·uimode 태그를 읽어 화자 이름과 이미지, 대화 UI를 갱신했습니다. 컷신 시작·종료에는 카메라와 플레이어 표시, 일반 UI의 활성 상태도 함께 전환해 대화와 연출 이후 게임으로 돌아오도록 했습니다.'
      ], image: { file: 'pagomoa/dialogue.jpg', alt: 'PagoMoa 인트로 컷신 중 화자 이미지와 대화창', caption: '타이틀·인트로 영상에서 대화가 진행되는 장면.' }, flow: ['Timeline 대화 마커', '재생 일시 정지', 'Ink 대화·선택지', 'Timeline 재개'] }
    ],
    problem: { title: '컷신 이후 플레이 상태 복원', paragraphs: [
      '컷신은 Timeline만 멈춘다고 끝나지 않습니다. 연출용 카메라, 숨겨 둔 플레이어, 비활성화한 UI를 함께 되돌려야 다음 플레이가 이어집니다.',
      'CutSceneController에서 시작과 종료 처리를 모았습니다. 시작할 때 일반 UI와 플레이어를 숨기고 카메라 설정을 바꾸며, 종료할 때 배우를 정리하고 기본 카메라·플레이어·UI를 복원합니다. 사용한 트리거와 Timeline 에셋 참조도 종료 경로에서 정리했습니다.'
    ] },
    technology: [
      { name: 'Unity · C#', use: '퀘스트 조건 객체와 인벤토리 슬롯 데이터, 게임플레이 이벤트 처리' },
      { name: 'ScriptableObject · CustomEditor', use: '퀘스트 조건·보상·대화를 데이터로 만들고 Inspector에서 편집' },
      { name: 'Timeline · Cinemachine', use: '컷신 재생, 대화 마커 처리와 연출용 카메라 전환' },
      { name: 'Ink · uGUI', use: '스토리·선택지·태그 파싱과 대화 UI 표시' }
    ]
  }
};
